import { useQuery } from "@tanstack/react-query";
import { slidesFolderApi } from "./slides-folder.api";
import { slidesFolderKeys } from "./slides-folder.keys";

export const useGetSlidesFoldersQuery = () => {
  return useQuery({
    queryKey: slidesFolderKeys.slidesFolders,
    queryFn: () => slidesFolderApi.getSlidesFolders(),
  });
};

export const useGetArchivedSlidesFoldersQuery = (
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: slidesFolderKeys.archivedSlidesFolders,
    queryFn: () => slidesFolderApi.getSlidesFolders({ archived: true }),
    enabled: options?.enabled ?? true,
  });
};
